export const macViewCheck = {
  path: '/api/v1/macs',
  method: 'GET',
};

export const macEditCheck = {
  path: '/api/v1/macs',
  method: 'PUT',
};

export function searchMacs(search, contentType) {
  return {
    accept: contentType,
    path: `macs${search}`,
  };
}

export function deleteMac(id) {
  return {
    method: 'DELETE',
    path: `macs/${id}`,
  };
}

export function createMac(tenantId, mac, name) {
  return {
    path: 'macs',
    body: JSON.stringify({
      bypass: true,
      mac,
      name,
      tenant_id: tenantId,
    }),
    method: 'POST',
  };
}

export function renameMac(macId, name) {
  return {
    path: `macs/${macId}`,
    body: JSON.stringify({ name }),
    method: 'PUT',
  };
}
